"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentGetResponseMapper = void 0;
var PaymentGetResponseMapper = /** @class */ (function () {
    function PaymentGetResponseMapper(data) {
        this.localData = data;
    }
    PaymentGetResponseMapper.prototype.getDataObject = function () {
        return this.localData;
    };
    return PaymentGetResponseMapper;
}());
exports.PaymentGetResponseMapper = PaymentGetResponseMapper;
//# sourceMappingURL=PaymentGetResponseMapper.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/models/mappers/PaymentGetResponseMapper.js
// module id = 2073
// module chunks = 8